import PropTypes from 'prop-types';

// project-imports
import Navigation from '../DrawerContent';

export default function VerticalDrawerContent({ selectedItems, setSelectedItems }) {
  return (
    <div style={{ height: 'calc(100vh - 74px)', overflowY: 'auto' }}>
      <Navigation selectedItems={selectedItems} setSelectedItems={setSelectedItems} />
    </div>
  );
}

VerticalDrawerContent.propTypes = { selectedItems: PropTypes.any, setSelectedItems: PropTypes.oneOfType([PropTypes.func, PropTypes.any]) };
